/**
 * 要素がクリッカブルかどうかを判定する
 *
 * @param element 判定対象のHTMLElement
 * @returns クリッカブルな要素の場合はtrue
 */
export const isClickableElement = (element: HTMLElement): boolean => {
  const tagName = element.tagName.toLowerCase();

  // 基本的なクリッカブルタグ
  if (tagName === "a" || tagName === "button") {
    return true;
  }

  // ロール属性による判定
  if (element.getAttribute("role") === "button") {
    return true;
  }

  // イベント属性による判定
  return element.hasAttribute("onclick") || element.hasAttribute("href");
};

/**
 * クリックイベントのターゲット要素またはその祖先要素にクリッカブルな要素が含まれているかを判定する
 *
 * この関数は行クリックイベントとセル内のクリッカブル要素のイベントが競合しないようにするために使用されます。
 * セル内にリンクやボタンがある場合、それらのクリックが行クリックより優先されるべきです。
 *
 * @param target クリックイベントのターゲット要素
 * @param currentTarget クリックイベントのcurrentTarget（探索を停止する要素）
 * @returns クリッカブルな要素が見つかった場合はtrue
 */
export const hasClickableAncestor = (
  target: HTMLElement,
  currentTarget: EventTarget | null,
): boolean => {
  let currentElement: HTMLElement | null = target;

  while (currentElement && currentElement !== currentTarget) {
    if (isClickableElement(currentElement)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }

  return false;
};
